import { useEffect, useState } from 'react';
import backend from '../api/server';

const useSubsidiaries = () => {
    const [refreshContent, setRefreshContent] = useState(false);
    const [state, setState] = useState({
        subsidiaries: [],
        isLoading: true,
        isError: false,
        errorMessage: '',
    });
    const [modals, setModals] = useState({
        subForm: false,
    });

    useEffect(() => {
        (async () => {
            setState((prevState) => ({
                ...prevState,
                isLoading: true,
                isError: false,
                errorMessage: '',
            }));

            try {
                const { data } = await backend.get('subsidiaries');
                setState((prevState) => ({
                    ...prevState,
                    subsidiaries: data,
                }));
            } catch (error) {
                setState((prevState) => ({
                    ...prevState,
                    isError: true,
                    errorMessage: error.response
                        ? error.response.data?.msg
                        : error.message,
                }));
            } finally {
                setState((prevState) => ({
                    ...prevState,
                    isLoading: false,
                }));
            }
        })();
    }, [refreshContent]);

    const refresh = () => setRefreshContent(!refreshContent);
    const openFormModal = () =>
        setModals((prevState) => ({ ...prevState, subForm: true }));
    const closeFormModal = () =>
        setModals((prevState) => ({ ...prevState, subForm: false }));

    const handleDelete = async (id) => {
        setState((prevState) => ({
            ...prevState,
            isLoading: true,
            isError: false,
            errorMessage: '',
        }));

        try {
            await backend.delete(`subsidiaries/${id}`);
            refresh();
        } catch (error) {
            setState((prevState) => ({
                ...prevState,
                isError: true,
                errorMessage: error.response
                    ? error.response.data?.msg
                    : error.message,
            }));
        } finally {
            setState((prevState) => ({
                ...prevState,
                isLoading: false,
            }));
        }
    };

    return {
        ...state,
        modals,

        //Methods
        refresh,
        openFormModal,
        closeFormModal,
        handleDelete,
    };
};

export default useSubsidiaries;
